import { UiBox, UiListItem, UiTooltip, UiTypography } from "@smp/ui";
import {
  REACT_APP__BUILD_ID,
  REACT_APP__ENVIRONMENT,
  REACT_APP__VERSION,
} from "@smp/utils";
import format from "date-fns/format";
import { useMemo, useState } from "react";

import { useInterval } from "@/hooks/use_interval";
import { useContextApp } from "@/screens/app/context/app";

import { useStyles } from "./time.css";

export const Time = () => {
  const {
    state: { isExpanded },
  } = useContextApp();

  const [date, setDate] = useState<Date>(new Date());

  const classes = useStyles();

  const formattedTime = useMemo(() => format(date, "HH:mm"), [date]);

  const formattedDate = useMemo(() => format(date, "dd MMMM"), [date]);

  useInterval(() => {
    setDate(new Date());
  }, 1000);

  return useMemo(
    () => (
      <UiListItem button className={classes.list_item}>
        {!isExpanded ? (
          <UiTooltip
            placement="right"
            title={`${formattedDate} ${formattedTime}`}
          >
            <UiBox
              alignItems="center"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              height={40}
            >
              <UiBox alignItems="center" display="flex" justifyContent="center">
                <UiTypography variant="body1">{formattedTime}</UiTypography>
              </UiBox>
              <UiBox alignItems="center" display="flex" justifyContent="center">
                <UiTypography style={{ opacity: 0.5 }} variant="caption">
                  {REACT_APP__VERSION}
                  {(REACT_APP__ENVIRONMENT === "staging" ||
                    REACT_APP__ENVIRONMENT === "staging.io") &&
                    REACT_APP__BUILD_ID && (
                      <>
                        <br />
                        {"#" + REACT_APP__BUILD_ID}
                      </>
                    )}
                </UiTypography>
              </UiBox>
            </UiBox>
          </UiTooltip>
        ) : (
          <UiBox
            alignItems="center"
            display="flex"
            flexDirection="column"
            flexGrow={1}
            justifyContent="center"
            height={40}
          >
            <UiBox alignItems="center" display="flex" justifyContent="center">
              <UiTypography variant="body1">
                {formattedTime}
                &nbsp;&nbsp;|&nbsp;&nbsp;
                {formattedDate}
              </UiTypography>
            </UiBox>
            <UiBox alignItems="center" display="flex" justifyContent="center">
              <UiTypography style={{ opacity: 0.5 }} variant="caption">
                {REACT_APP__VERSION}
              </UiTypography>
            </UiBox>
          </UiBox>
        )}
      </UiListItem>
    ),
    [classes.list_item, formattedDate, formattedTime, isExpanded],
  );
};
